import { render, staticRenderFns } from "./ComprehensiveNav.vue?vue&type=template&id=5b9f1cee&scoped=true&"
import script from "./ComprehensiveNav.vue?vue&type=script&lang=js&"
export * from "./ComprehensiveNav.vue?vue&type=script&lang=js&"
import style0 from "./ComprehensiveNav.vue?vue&type=style&index=0&id=5b9f1cee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9f1cee",
  null
  
)

export default component.exports